<div class="container">
  <div
    class="m-t-16 w-100"
    [class.text-right]="mode === modes.USERS"
    [class.filters-export-container]="mode !== modes.USERS"
  >
    <label for="withSubscriptions" *ngIf="mode !== modes.USERS && viewMode === viewModes.LIST">
      <input
        type="checkbox"
        [(ngModel)]="withSubscriptions"
        id="withSubscriptions"
        name="withSubscriptions"
        (change)="refreshList()"
      />
      Show users without subscriptions
    </label>
    <button
      *ngIf="mode === modes.USERS"
      type="button"
      class="btn btn-default report-button"
      (click)="generateReport()"
    >
      <i class="fa fa-file-excel-o"></i>Excel Report
    </button>
    <ng-container *ngIf="(mode === modes.CUSTOMERS) && (isSuperAdmin || isAdmin)">
      <ng-container *ngIf="viewMode === viewModes.REPORT">
        <label for="user" class="filter-label">
          Select user:
          <ng-select
            [items]="allUsers"
            bindLabel="label"
            placeholder="User"
            [searchable]="true"
            id="user"
            class="filter"
            (change)="handleUserFilter($event)"
          />
        </label>
        <label for="paymentMethod" class="filter-label">
          Select payment method:
          <ng-select
            [items]="paymentMethods"
            placeholder="Payment Method"
            [searchable]="true"
            id="paymentMethod"
            class="filter"
            (change)="handlePaymentMethodFilter($event)"
          >
            <ng-template ng-option-tmp let-item="item">
              {{ item }}
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              {{ item }}
            </ng-template>
          </ng-select>
        </label>
        <label for="subscription" class="filter-label">
          Select subscription:
          <ng-select
            [items]="subscriptions"
            placeholder="Subscription"
            [searchable]="true"
            id="subscription"
            class="filter"
            (change)="handleSubscriptionFilter($event)"
          >
            <ng-template ng-option-tmp let-item="item">
              {{ item.name }}
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              {{ item.name }}
            </ng-template>
          </ng-select>
        </label>
        <label for="datepicker" class="filter-label">
          Select date:
          <div class="input-group">
            <div class="dp-hidden position-absolute">
              <input
                name="datepicker"
                id="datepicker"
                ngbDatepicker
                #datepicker="ngbDatepicker"
                [autoClose]="false"
                (dateSelect)="handleDateSelectFilter($event)"
                [displayMonths]="1"
                [dayTemplate]="dayTemplate"
                [footerTemplate]="footerTemplate"
                outsideDays="hidden"
                [startDate]="fromDate!"
                tabindex="-1"
              />
              <ng-template #dayTemplate let-date let-focused="focused">
          <span
            class="custom-day"
            [class.focused]="focused"
            [class.range]="isRange(date)"
            [class.faded]="
              (isHovered(date) || isInside(date))
            "
            (mouseenter)="hoveredDate = date"
            (mouseleave)="hoveredDate = null"
          >
            {{ date.day }}
          </span>
              </ng-template>
              <ng-template #footerTemplate>
                <div class="calendar-footer">
                  <button
                    class="btn btn-outline-danger btn-sm"
                    (click)="close()"
                  >
                    Clear
                  </button>
                  <button
                    class="btn btn-outline-primary btn-sm"
                    (click)="checkRangeAndGetBookedLessons()"
                  >
                    Ok
                  </button>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="input-group">
            <input
              #dpFromDate
              class="form-control"
              name="dpFromDate"
              [value]="getFromToDate(fromDate, toDate)"
              (input)="fromDate = validateInput(fromDate, dpFromDate.value)"
              (click)="datepicker.toggle()"
            />
          </div>
        </label>
      </ng-container>
      <button
        type="button"
        class="btn btn-default report-button"
        (click)="changeCustomersViewMode()"
      >
        {{viewMode === viewModes.LIST ? 'View Payment Report' : 'Back to Customers List'}}
      </button>
    </ng-container>

  </div>
  <ng-container *ngIf="viewMode === viewModes.LIST; else reportView">
    <div class="user-list mt-3 mb-3 table-responsive" *ngIf="users?.length > 0">
      <table class="table table-responsive-lg">
        <thead>
        <tr>
          <th scope="col" class="text-center">#</th>
          <th scope="col" class="text-center">First name</th>
          <th scope="col" class="text-center">Last name</th>
          <th scope="col" class="text-center">Email</th>
          <th scope="col" class="text-center">Phone</th>
          <th scope="col" class="text-center">Registration date</th>
          <th scope="col" class="text-center">Children details</th>
          <th scope="col" class="text-center">Subscriptions list</th>
          <th scope="col" class="text-center" *ngIf="mode === modes.USERS">
            Roles list
          </th>
          <th *ngIf="true || !isSuperAdmin"></th>
          <th *ngIf="true || !isSuperAdmin"></th>
        </tr>
        </thead>
        <tbody>
        <tr
          *ngFor="
            let user of users
              | paginate
                : {
                    itemsPerPage: pageSize,
                    currentPage: pageNumber,
                    totalItems: totalElements
                  };
            let i = index
          "
        >
          <th class="text-center">{{ user.id }}</th>
          <td class="text-center">{{ user.firstName }}</td>
          <td class="text-center">{{ user.lastName }}</td>
          <td class="text-center">{{ user.email.value }}</td>
          <td class="text-center">{{ user.phone.value }}</td>
          <td class="text-center">
            {{ user.registrationDate | date : "dd.MM.yyyy HH:mm:ss" }}
          </td>
          <td class="text-center">
            <button
              type="button"
              class="btn btn-info info-button"
              (click)="openChildrenInfoModal(user)"
              title="Children details"
            >
              <i class="fas fa-eye"></i>
            </button>
            <i class="fa fa-exclamation-triangle exclamation-icon" *ngIf="checkAllergies(user?.children)"></i>
          </td>
          <td class="text-center">
            <button
              *ngIf="user?.subscriptions?.length > 0"
              type="button"
              class="btn btn-info info-button mr-2"
              (click)="openSubscriptionsInfoModal(user)"
            >
              <i class="fas fa-eye"></i>
            </button>
            <button
              type="button"
              class="btn btn-info info-button"
              (click)="openAddUserSubscriptionModal(user)"
            >
              <i class="fas fa-add"></i>
            </button>
          </td>
          <td class="text-center" *ngIf="mode === modes.USERS">
            {{ formatRoles(user) }}
          </td>
          <td class="text-center" *ngIf="isSuperAdmin || isAdmin">
            <button
              type="button"
              class="btn btn-light edit-button"
              (click)="openEditModal(user)"
            >
              <i class="fas fa-pencil"></i>
            </button>
          </td>
          <td class="text-center" *ngIf="isSuperAdmin || isAdmin">
            <button
              type="button"
              class="btn btn-danger delete-button"
              (click)="openDeleteConfirmModal(user)"
            >
              <i class="fas fa-trash"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="totalElements > 0" class="row justify-content-center">
      <div class="col-md-auto">
        <pagination-controls
          previousLabel="Prev"
          nextLabel="Next"
          responsive="true"
          (pageChange)="handlePageChange($event)"
        ></pagination-controls>
      </div>
      <div class="col-md-auto">
        Items per page:
        <select (change)="handlePageSizeChange($event)">
          <option *ngFor="let size of pageSizes" [ngValue]="size">
            {{ size }}
          </option>
        </select>
      </div>
      <div class="col-md-auto">
        <div>
          {{ getMinLimit() }}-{{ getMaxLimit() }} of {{ totalElements }} items
        </div>
      </div>
    </div>
    <div class="text-center" *ngIf="isSuperAdmin || isAdmin">
      <button
        type="button"
        class="btn btn-default add-button"
        (click)="openEditModal(null)"
      >
        <i class="fas fa-plus"></i> Add new
      </button>
    </div>
  </ng-container>

  <ng-template #reportView>
    <div class="user-list mt-3 mb-3 table-responsive" *ngIf="users?.length > 0">
      <table class="table table-responsive-lg">
        <thead>
        <tr>
          <th scope="col" class="text-center">User name</th>
          <th scope="col" class="text-center" sortable="subscriptionName" (sort)="onSort($event)"><span>Subscription name</span></th>
          <th scope="col" class="text-center" sortable="createdDate"(sort)="onSort($event)"><span>Purchase date</span></th>
          <th scope="col" class="text-center">Amount</th>
          <th scope="col" class="text-center" sortable="paymentMethod"(sort)="onSort($event)"><span>Payment method</span></th>
        </tr>
        </thead>
        <tbody>
        <tr
          *ngFor="
            let payment of payments
              | paginate
                : {
                    itemsPerPage: reportPageSize,
                    currentPage: reportPageNumber,
                    totalItems: reportTotalElements
                  };
            let i = index
          "
        >
          <td class="text-center">{{payment.userName}}</td>
          <td class="text-center">{{payment.subscriptionName}}</td>
          <td class="text-center">{{payment.purchaseDate | date : "dd.MM.yyyy HH:mm:ss"}}</td>
          <td class="text-center">{{payment.amount}}</td>
          <td class="text-center">{{payment.paymentMethod}}</td>
        </tr>
        <tr *ngIf="payments.length === 0">
          <td colspan="5" class="text-center">No payments found</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="reportTotalElements > 0" class="row justify-content-center">
      <div class="col-md-auto">
        <pagination-controls
          previousLabel="Prev"
          nextLabel="Next"
          responsive="true"
          (pageChange)="handleReportPageChange($event)"
        ></pagination-controls>
      </div>
      <div class="col-md-auto">
        Items per page:
        <select (change)="handleReportPageSizeChange($event)">
          <option *ngFor="let size of pageSizes" [ngValue]="size">
            {{ size }}
          </option>
        </select>
      </div>
      <div class="col-md-auto">
        <div>
          {{ getReportMinLimit() }}-{{ getReportMaxLimit() }} of {{ reportTotalElements }} items
        </div>
      </div>
    </div>
  </ng-template>
</div>
